import { connectColors, themeColors } from '@/theme/colors';
import { Button, Icon, Menu } from '@lego/connect-components-react';
import type { IconName } from '@lego/icons';
import { useRef, useState } from 'react';

type ActionItem = {
  value: string;
  label: string;
  icon: IconName;
  triggerRef: React.RefObject<HTMLLIElement | null>;
  onClick: () => void;
};

export type Action = {
  onClick: () => void;
  triggerRef: React.RefObject<HTMLLIElement | null>;
};

type ActionsDropdownProps = {
  disabled?: boolean;
  download?: Action;
  versionHistory?: Action;
  uploadFile?: Action;
};

const ActionsDropdown = ({
  disabled = false,
  download,
  versionHistory,
  uploadFile,
}: ActionsDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const items: ActionItem[] = [
    ...(download
      ? [
          {
            value: 'download-excel',
            label: 'Download excel',
            icon: 'arrow-down-to-line' as IconName,
            triggerRef: download?.triggerRef,
            onClick: download?.onClick,
          },
        ]
      : []),
    ...(versionHistory
      ? [
          {
            value: 'version-history',
            label: 'Version history',
            icon: 'clock-rotate-left' as IconName,
            triggerRef: versionHistory?.triggerRef,
            onClick: versionHistory?.onClick,
          },
        ]
      : []),
    ...(uploadFile
      ? [
          {
            value: 'upload-file',
            label: 'Upload file',
            icon: 'arrow-up-to-line' as IconName,
            triggerRef: uploadFile?.triggerRef,
            onClick: uploadFile?.onClick,
          },
        ]
      : []),
  ];

  return (
    <>
      <Button
        ref={anchorRef}
        disabled={disabled}
        appearance="ghost"
        size="small"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label="Actions"
        iconName="chevron-down-solid"
        iconPosition="end"
        style={{ color: themeColors.content.default }}
      >
        Actions
      </Button>
      <Menu
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        anchorRef={anchorRef}
        aria-labelledby="actions-menu"
        offset={4}
      >
        {items.map((item) => (
          <Menu.Item
            ref={item.triggerRef}
            key={item.value}
            value={item.value}
            onClick={() => {
              item.onClick();
              setIsOpen(false);
            }}
          >
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: connectColors.core.blue[1000],
              }}
            >
              <Icon name={item.icon} size="small" aria-label={item.value} />
              {item.label}
            </span>
          </Menu.Item>
        ))}
      </Menu>
    </>
  );
};
export default ActionsDropdown;
